export default "__VITE_ASSET__BGKvJ1dK__"